/// <reference path="../../../../typings/tsd.d.ts" /> 

module warsApp.controllers {
    export interface ApiActionControllerScope extends angular.IScope {
        model: models.ApiActionsModel;

    }

    export class ApiActionsController implements IController {

        constructor(scope: ApiActionControllerScope, $routeParams: angular.route.IRouteParamsService,
            growlService: angular.growl.IGrowlService,
            apiConfigurationService: services.ApiActionService,
            objectQueryService: services.ObjectQueryService,
            objectSchemaService: services.ObjectSchemaService,
            apiSchemaMappingService: services.ApiSchemaMappingService) {

            var processConfigurationId: string = $routeParams["id"];
            scope.model = new models.ApiActionsModel(processConfigurationId, apiConfigurationService, objectQueryService, objectSchemaService, apiSchemaMappingService);
        }
    }
}
warsApp.registerController('ApiActionsController',
    ['$scope', '$routeParams', 'growl', 'apiActionService', 'objectQueryService', 'objectSchemaService', 'apiSchemaMappingService']
);